
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"19","viewBox":"0 0 23 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#menu_svg__clip0_1438_4848)"}},[_c('path',{attrs:{"d":"M2 17.306h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H2c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2zm0-7h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H2c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2zm-1.2-8.2c0 .66.54 1.2 1.2 1.2h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H2c-.66 0-1.2.54-1.2 1.2z","fill":"#07193D"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"menu_svg__clip0_1438_4848"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .106)","d":"M0 0h23v18H0z"}})])])])
          )
        }
      }
    